import React from 'react'
import { Link } from 'react-router'
import EditIcon from '../../../img/icons/general-icons/icon_edit.png'

export default class LinkUpdateType extends React.Component {
  render () {
    var url = 'type/' + this.props.rowData.Nombre
    return (
      <Link to={url}>
        <img src={EditIcon}/>
      </Link>
    )
  }
}

/* Validate Props */
LinkUpdateType.propTypes = {
  rowData: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Type/SearchType/LinkUpdateType.js